module.exports = "<a ng-click=\"$ctrl.redirectToLicensRenewalForm()\"\r\n   href=\"\">\r\n    <translate>\r\n        Renew\r\n    </translate>\r\n    \r\n    <i class=\"fa fa-external-link\"\r\n       aria-hidden=\"true\">\r\n    </i>\r\n</a>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/dashboard/components/dashboard-widget/license-renewal/components/link-to-license-renewal-form/link-to-license-renewal-form.html
// module id = 1668
// module chunks = 0